import { Practitioner } from 'src/models';
import { Avatar } from 'antd';
import { generateColorFromName, getPractitionerName } from 'src/utils';

type PractitionerNameProps = {
  practitioner: Practitioner;
  avatar?:
    | {
        size?: number;
      }
    | false;
};

export const PractitionerName = ({
  practitioner,
  avatar = { size: 24 },
}: PractitionerNameProps) => {
  const { first_name, last_name } = practitioner;

  const name = getPractitionerName(practitioner) || '';
  const nameParts = [first_name, last_name];
  const initials = nameParts
    .map((part) => part?.[0])
    .join('')
    .toUpperCase();
  return (
    <div className="flex items-center gap-2">
      {avatar && (
        <Avatar
          style={{
            flexShrink: 0,
            color: 'white',
            backgroundColor: generateColorFromName(name),
          }}
          {...(typeof avatar === 'object' ? avatar : {})}
        >
          {initials}
        </Avatar>
      )}
      <span>{name}</span>
    </div>
  );
};
